import { space } from '@sunwebgroup/ui-components'
import { Button, Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useLocation } from '@/scopes/common/infrastructure/dom/location'
import { addFavoriteParam } from '@/scopes/favourites/domain/addFavoriteParam'
import { addReturnUrl } from '@/scopes/favourites/domain/addReturnUrl'
import { useResults } from '@/scopes/search/search/domain/hooks'
import { ProductCardCompact } from './ProductCardCompact'

const FooterButton = styled(Button)`
  flex-basis: 50%;
`

const SheetFooter = styled(Sheet.Footer)`
  flex-direction: row;
  gap: ${space('primitives_space_8')};
`

const ContentText = styled(Typography)`
  margin-top: ${space('primitives_space_32')};
`
export function LogInSheet({ productId, onClose }: { productId: number, onClose: () => void }): React.ReactElement {
  const intl = useIntl()
  const { results } = useResults()
  const location = useLocation()
  const loginUrl = useConfiguration('links.login')
  const createAccountUrl = useConfiguration('links.createAccount')

  const product = React.useMemo(() => results.find(({ id }) => id === productId), [results, productId])
  const returnUrl = encodeURIComponent(addFavoriteParam(location.pathQueryFragment(), productId))
  return (
    <Sheet.Body side="right">
      <Sheet.Header titleLabel={intl.formatMessage({ id: 'favorite_login_modal_title' })} closeLabel={intl.formatMessage({ id: 'close' })} />
      <Sheet.Content>
        {product && (
          <ProductCardCompact
            id={product.id}
            accommodationId={product.id}
            imageSources={product.images}
            href={product.url}
            name={product.name}
            userRating={product.userRating}
            userRatingText={product.userRatingText}
            locations={product.locations}
            rating={product.rating ?? 0}
          />
        )}
        <ContentText variant="body-l-regular-snug" forwardedAs="p">{intl.formatMessage({ id: 'favorite_login_modal_text' })}</ContentText>
      </Sheet.Content>
      <SheetFooter>
        <FooterButton
          variant="secondary"
          onClick={() => {
            location.redirectTo(addReturnUrl(createAccountUrl, returnUrl))
            onClose()
          }}
        >
          {intl.formatMessage({ id: 'favorite_login_modal_secondary_action_text' })}
        </FooterButton>
        <FooterButton
          variant="primary"
          onClick={() => {
            location.redirectTo(addReturnUrl(loginUrl, returnUrl))
            onClose()
          }}
        >
          {intl.formatMessage({ id: 'favorite_login_modal_primary_action_text' })}
        </FooterButton>
      </SheetFooter>
    </Sheet.Body>
  )
}
